export default {
  labels: {
    google_place: 'Lieu Google',
    menu_import: 'Importation de menu',
    live: 'En ligne',
    setting_up: 'Configuration',
  },
  buttons: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
    continue_setup: 'Continuer la configuration',
  },
  delete_confirmation: 'Êtes-vous sûr ?',
};
